import React from 'react';
import ModuleEditablePopup from '../moduleEditablePopup/ModuleEditablePopup';
import DeleteModulePopup from './DeleteModulePopup';

export const columnSetter = (moduleType, authLevel, moduleCalibrateCompletion, dataReloadFunc) => {
  let syncColumns = [];

  switch (moduleType) {
    case 'DT':
      syncColumns = dtTypeColumn;
      break;
    case 'IT':
      syncColumns = itTypeColumn;
      break;
    default:
      syncColumns = allTypeColumn;
      break;
  }

  const columns = [
    {
      Header: '장치정보',
      columns: [
        ...syncColumns,
        {
          id: 'mButton',
          Header: () => <div></div>,
          Cell: ({ row }) => (
            <ModuleEditablePopup row={row} module={row.original} dataReloadFunc={dataReloadFunc}>
              <div>
                <button className="table-search-submit btn btn-info">수정</button>
              </div>
            </ModuleEditablePopup>
          ),
        },
        {
          id: 'dButton',
          Header: () => <div></div>,
          Cell: ({ row }) => (
            <>
              {(authLevel === 1 || authLevel === 2) && (
                <DeleteModulePopup row={row} module={row.original} dataReloadFunc={dataReloadFunc}>
                  <div>
                    <button className="table-search-submit btn btn-info">삭제</button>
                  </div>
                </DeleteModulePopup>
              )}
            </>
          ),
        },
        {
          id: 'cButton',
          Header: () => <div></div>,
          Cell: ({ row }) => (
            <>
              {row.original.calibration !== null && (
                <div>
                  <button
                    onClick={() => {
                      moduleCalibrateCompletion(row.original.moduleIdx);
                    }}
                    className="table-search-submit btn btn-info"
                  >
                    교정완료
                  </button>
                </div>
              )}
            </>
          ),
        },
      ],
    },
  ];

  return columns;
};

const allTypeColumn = [
  {
    Header: <div></div>,
    accessor: 'index',
  },
  {
    Header: '고유번호',
    accessor: 'modelNo',
  },
  {
    Header: '장치명',
    accessor: 'modelNm',
  },
  {
    Header: '장치상태',
    accessor: 'moduleStatus',
    Cell: ({ row }) => <div>{convertModuleStatus(row.original.moduleStatus)}</div>,
  },
  {
    Header: '장치그룹',
    accessor: 'moduleGroup',
    Cell: ({ row }) => <div>{row.original.moduleGroup !== null && row.original.moduleGroup.modelNm}</div>,
  },
  {
    Header: '교정 유효기간',
    accessor: 'deadline',
    Cell: ({ row }) => (
      <div>
        {row.original.deadline !== '' &&
          ((new Date(row.original.deadline) - new Date()) / 8.64e7 < 31 ? (
            <span style={{ color: '#ff0000' }}>{row.original.deadline} 까지</span>
          ) : (
            `${row.original.deadline} 까지`
          ))}
      </div>
    ),
  },
  {
    Header: <span title={`이동형 : 착용자가 소지하는 장치${'\n'}휴대형 : 특정 장소에 고정/고정하는 장치`}>운용유형</span>,
    accessor: 'moduleTypeNm',
  },
  {
    Header: <span title="장치가 검지하는 유형">검지유형</span>,
    accessor: 'moduleScnNm',
  },
  {
    Header: <span title="휴대형 장치를 고정한 장소">설비번호</span>,
    accessor: 'areaNo',
  },
  {
    Header: <span title="휴대형 장치를 고정한 장소">설비정보</span>,
    accessor: 'areaNm',
  },
  {
    Header: '관리자',
    accessor: 'auth',
  },
  {
    Header: '등록자',
    accessor: 'rgstId',
  },
  {
    Header: '등록일',
    accessor: 'rgstDt',
  },
];

const dtTypeColumn = [
  {
    Header: <div></div>,
    accessor: 'index',
  },
  {
    Header: '고유번호',
    accessor: 'modelNo',
  },
  {
    Header: '장치명',
    accessor: 'modelNm',
  },
  {
    Header: '교정 유효기간',
    accessor: 'deadline',
    Cell: ({ row }) => (
      <div>
        {row.original.deadline !== '' &&
          ((new Date(row.original.deadline) - new Date()) / 8.64e7 < 31 ? (
            <span style={{ color: '#ff0000' }}>{row.original.deadline} 까지</span>
          ) : (
            `${row.original.deadline} 까지`
          ))}
      </div>
    ),
  },
  {
    Header: <span title="장치가 검지하는 유형">검지유형</span>,
    accessor: 'moduleScnNm',
  },
  {
    Header: '관리자',
    accessor: 'auth',
  },
  {
    Header: '등록자',
    accessor: 'rgstId',
  },
  {
    Header: '등록일',
    accessor: 'rgstDt',
  },
];

const itTypeColumn = [
  {
    Header: <div></div>,
    accessor: 'index',
  },
  {
    Header: '고유번호',
    accessor: 'modelNo',
  },
  {
    Header: '장치명',
    accessor: 'modelNm',
  },
  {
    Header: '교정 유효기간',
    accessor: 'deadline',
    Cell: ({ row }) => (
      <div>
        {row.original.deadline !== '' &&
          ((new Date(row.original.deadline) - new Date()) / 8.64e7 < 31 ? (
            <span style={{ color: '#ff0000' }}>{row.original.deadline} 까지</span>
          ) : (
            `${row.original.deadline} 까지`
          ))}
      </div>
    ),
  },
  {
    Header: <span title="장치가 검지하는 유형">검지유형</span>,
    accessor: 'moduleScnNm',
  },
  {
    Header: <span title="휴대형 장치를 고정한 장소">설비번호</span>,
    accessor: 'areaNo',
  },
  {
    Header: <span title="휴대형 장치를 고정한 장소">설비명</span>,
    accessor: 'areaNm',
  },
  {
    Header: '관리자',
    accessor: 'auth',
  },
  {
    Header: '등록자',
    accessor: 'rgstId',
  },
  {
    Header: '등록일',
    accessor: 'rgstDt',
  },
];

const convertModuleStatus = (status) => {
  switch (status) {
    case 'blue':
      return '정상';
    case 'fix':
      return '점검 중';
    case 'cali':
      return '교정 중';
    default:
      return '정상';
  }
};
